import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgxSplideModule } from 'ngx-splide';
import { sliderOptions } from '@app/domain/properties/slider.properties';

@Component({
  selector: 'bingo-how-it-works-bingoal',
  imports: [NgxSplideModule],
  templateUrl: './how-it-works-bingoal.component.html',
  styleUrl: './how-it-works-bingoal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HowItWorksBingoalComponent {
  protected readonly sliderOptions = sliderOptions;
}
